import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useState, useCallback } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useSelector } from 'store';
import { GetAllBranchesNewsAPI, GetBranchNewsAPI } from 'api/community';
import { ERROR_500 } from 'constants/message';
import { useDispatch } from 'react-redux';
import { communityActions } from 'store/community';
import BranchFeedCard from './components/BranchFeedCard';
import BranchEventCard from './components/BranchEventCard';
import ClusterMenuFeed from './components/ClusterMenuFeed';
import { Spinner } from '../common/Spinner';

var ActivityListService = function ActivityListService() {
  var _useState = useState('ALL'),
      selected = _useState[0],
      setSelected = _useState[1];

  var _useState2 = useState(10),
      count = _useState2[0],
      setCount = _useState2[1];

  var dispatch = useDispatch();
  var branch_news = useSelector(function (state) {
    return state.community.branch_news;
  });
  var feeds = branch_news.results;
  var has_more = branch_news.has_more;
  var onLoadMore = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var value, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            value = count + 10;

            if (!(selected === 'ALL')) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return GetAllBranchesNewsAPI(value);

          case 4:
            response = _context.sent;
            _context.next = 10;
            break;

          case 7:
            _context.next = 9;
            return GetBranchNewsAPI(selected, value);

          case 9:
            response = _context.sent;

          case 10:
            if (!(response.status >= 400)) {
              _context.next = 13;
              break;
            }

            alert(ERROR_500);
            return _context.abrupt("return");

          case 13:
            dispatch(communityActions.setBranchNews(response.data));
            setCount(value);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [count, dispatch, selected]);

  var callbackMenu = function callbackMenu(id) {
    setSelected(id);
    setCount(10);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ClusterMenuFeed, {
      selected: selected,
      callback: callbackMenu
    }), /*#__PURE__*/_jsx("div", {
      className: "cnts-wrap",
      children: /*#__PURE__*/_jsx("div", {
        className: "activity-list",
        children: /*#__PURE__*/_jsx(InfiniteScroll, {
          pageStart: 0,
          loadMore: onLoadMore,
          hasMore: has_more,
          loader: /*#__PURE__*/_jsx(Spinner, {}),
          children: feeds.length > 0 ? feeds.map(function (feed, index) {
            if (feed.type === 'event') return /*#__PURE__*/_jsx(BranchEventCard, {
              feed: feed
            }, index);
            if (feed.type === 'post') return /*#__PURE__*/_jsx(BranchFeedCard, {
              feed: feed
            }, index);
            if (feed.type === 'notice') return null;
          }) : null
        })
      })
    })]
  });
};

export default ActivityListService;